import styles from "./styles.module.css";

export default function WatermarkBuilding() {
  return <span className={styles.container}>Edifício São Luiz</span>;
}
